const DEMOGRAPHIC_TYPES = {
  GENDER: 'gender',
  YEAR_OF_BIRTH: 'dg_year_of_birth',
  AGE: 'age',
  MARITAL_STATUS: 'marital_status',
  PARENTAL: 'dg_parental',
  EDUCATION: 'dg_education',
  EMPLOYMENT: 'dg_employment',
  CAREER: 'dg_career',
  RACE: 'dg_race',
  INCOME: 'dg_income',
  LANGUAGES: 'dg_speaking_langs',
  EMPLOYEES: 'dg_number_of_employees',
  ROLE: 'dg_organization_role',
  MANUFACTURER: 'manufacturer',
  MOBILE_CARRIER: 'mobile_carrier',
  OS_PLATFORM: 'os',
};

export default DEMOGRAPHIC_TYPES;
